export enum VendorCodeType {
  COMMERCIAL = 'Commercial',
  INTERNET = 'Internet',
}
